





















































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class SiteMessagesForm extends Vue {
  private dropdown_edit: Array<object> = [{ text: '100%' }, { text: '75%' }, { text: '50%' }, { text: '25%' }, { text: '0%' }]

  // TODO: Click event handler for on-save
  private saveSiteMessage() {
    // TODO: Validate the form
    console.log('Saving.....')
  }

  // TODO: Click event handler for close
  private closeForm() {
    // Dialog to false to close the form
    console.log('Closing form.....')
  }

  // Methods
}
